/* GDS Home JS — v7
 * Mobile menu · Mega dept panels · Reveal observer · Carousel scroll · Hotspot · Countdown
 */
(function () {
  'use strict';

  /* ─── Mobile Menu ─── */
  const burgerBtn  = document.getElementById('gdsBurgerBtn');
  const mobilePanel = document.getElementById('gdsMobilePanel');
  const scrim      = document.getElementById('gdsScrim');
  const closeBtn   = document.getElementById('gdsCloseBtn');

  function openMenu()  { if (!mobilePanel) return; mobilePanel.classList.add('open');    document.body.style.overflow = 'hidden'; }
  function closeMenu() { if (!mobilePanel) return; mobilePanel.classList.remove('open'); document.body.style.overflow = ''; }

  if (burgerBtn)  burgerBtn.addEventListener('click', openMenu);
  if (scrim)      scrim.addEventListener('click', closeMenu);
  if (closeBtn)   closeBtn.addEventListener('click', closeMenu);

  /* ─── Copy welcome / discount codes ─── */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.js-gds-copy-code');
    if (!btn) return;
    e.preventDefault();
    var code = btn.getAttribute('data-gds-copy-code') || '';
    if (!code) return;

    function markCopied() {
      btn.classList.add('is-copied');
      btn.setAttribute('aria-label', 'Copied ' + code);
      window.clearTimeout(btn._gdsCopyTimer);
      btn._gdsCopyTimer = window.setTimeout(function () {
        btn.classList.remove('is-copied');
        btn.setAttribute('aria-label', 'Copy code ' + code);
      }, 1600);
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(markCopied).catch(function () {
        fallbackCopy(code, markCopied);
      });
    } else {
      fallbackCopy(code, markCopied);
    }
  });

  function fallbackCopy(text, onSuccess) {
    try {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      var ok = document.execCommand('copy');
      document.body.removeChild(ta);
      if (ok && onSuccess) onSuccess();
    } catch (err) {}
  }

  /* ─── Mobile search show/hide ─── */
  function toggleMobileSearch() {
    const row = document.querySelector('.gds-mobile-search');
    if (!row) return;
    row.style.display = window.innerWidth <= 980 ? 'block' : 'none';
  }
  toggleMobileSearch();
  window.addEventListener('resize', toggleMobileSearch);

  /* ─── Header search: products-only, department → collection/tag ─── */
  function gdsBuildSearchUrl(query, deptOpt, form) {
    var q = (query || '').trim();
    var collectionUrl = deptOpt && deptOpt.getAttribute('data-collection-url');
    var tag = deptOpt && deptOpt.getAttribute('data-tag');
    var handle = deptOpt && deptOpt.value;

    if (handle && !q && collectionUrl) {
      return collectionUrl;
    }

    var params = new URLSearchParams();
    params.set('type', 'product');
    params.set('options[prefix]', 'last');
    if (q) params.set('q', q);
    if (handle) params.set('gds_dept', handle);
    if (tag) params.set('filter.p.tag', tag);

    var searchBase = (form && form.getAttribute('action')) || '/search';
    return searchBase + '?' + params.toString();
  }

  function gdsClosePredictive(root) {
    var wrap = root && root.querySelector('[data-gds-ps-results]');
    if (wrap) {
      wrap.hidden = true;
      wrap.innerHTML = '';
    }
  }

  function gdsDebounce(fn, wait) {
    var t;
    return function () {
      var ctx = this;
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  /* Predictive typeahead — uses Enterprise Predictive Search section API */
  document.querySelectorAll('[data-gds-predictive]').forEach(function (root) {
    var form = root.querySelector('[data-gds-search-form]');
    var input = root.querySelector('.js-gds-search-input');
    var results = root.querySelector('[data-gds-ps-results]');
    if (!form || !input || !results) return;

    var cache = {};
    var abortCtrl = null;
    var predictiveBase = (window.theme && theme.routes && theme.routes.predictiveSearch) || '/search/suggest';

    var fetchResults = gdsDebounce(async function () {
      var q = input.value.trim();
      if (q.length < 2) {
        gdsClosePredictive(root);
        return;
      }

      var fields = 'title,product_type,variants.title,vendor,tag,variants.sku';
      var params = new URLSearchParams();
      params.set('q', q);
      params.set('resources[type]', 'product,collection,query');
      params.set('resources[limit]', '8');
      params.set('resources[limit_scope]', 'each');
      params.set('resources[options][fields]', fields);
      params.set('resources[options][unavailable_products]', 'last');
      params.set('section_id', 'gds-predictive-search');
      var key = params.toString();

      if (cache[key]) {
        results.innerHTML = cache[key];
        results.hidden = false;
        return;
      }

      try {
        if (abortCtrl) abortCtrl.abort();
        abortCtrl = new AbortController();
        results.hidden = false;
        results.innerHTML = '<div class="gds-ps gds-ps--loading"><p>Searching…</p></div>';

        var res = await fetch(predictiveBase + '?' + key, { signal: abortCtrl.signal });
        if (!res.ok) throw new Error(String(res.status));
        var html = await res.text();
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var section = tmp.querySelector('.shopify-section') || tmp;
        var markup = section.innerHTML || '';
        cache[key] = markup;
        results.innerHTML = markup;
        if (!markup.trim()) gdsClosePredictive(root);
      } catch (err) {
        if (err && err.name === 'AbortError') return;
        gdsClosePredictive(root);
      }
    }, 220);

    input.addEventListener('input', fetchResults);
    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2 && results.innerHTML.trim()) {
        results.hidden = false;
      }
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) gdsClosePredictive(root);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') gdsClosePredictive(root);
    });
  });

  document.querySelectorAll('[data-gds-search-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var root = form.closest('[data-gds-predictive]');
      var input = form.querySelector('input[name="q"]');
      var select = form.querySelector('[data-gds-search-dept]');
      var q = input ? input.value.trim() : '';
      var deptOpt = select && select.value ? select.options[select.selectedIndex] : null;

      if (!q && !(deptOpt && deptOpt.value)) {
        if (input) {
          input.focus();
          input.setAttribute('aria-invalid', 'true');
        }
        return;
      }

      if (input) input.removeAttribute('aria-invalid');
      if (root) gdsClosePredictive(root);
      window.location.href = gdsBuildSearchUrl(q, deptOpt, form);
    });
  });

  /* ─── Department select → open that department's collection (HI-05) ───
   * The select only updated its own value before; nothing navigated unless the
   * search form was submitted separately.
   */
  var GDS_ALL_DEPTS_URL = '/collections/all';

  function gdsDeptTarget(select) {
    if (!select) return '';
    var opt = select.options[select.selectedIndex];
    if (!opt || !opt.value) return GDS_ALL_DEPTS_URL;
    // Always the collection itself: tag-based scoping is not enabled as a
    // storefront filter, so a tag/search URL would silently ignore the department.
    return opt.getAttribute('data-collection-url') || ('/collections/' + opt.value);
  }

  function gdsGoToDept(select) {
    var url = gdsDeptTarget(select);
    if (!url) return;
    var form = select.closest('[data-gds-search-form]') || select.closest('form');
    var root = form && form.closest('[data-gds-predictive]');
    if (root) gdsClosePredictive(root);
    if (url === window.location.pathname) return;
    window.location.href = url;
  }

  document.querySelectorAll('[data-gds-search-dept]').forEach(function (select) {
    if (select.dataset.gdsDeptNavBound === '1') return;
    select.dataset.gdsDeptNavBound = '1';

    var BROWSE_KEYS = {
      ArrowDown: 1, ArrowUp: 1, ArrowLeft: 1, ArrowRight: 1,
      Home: 1, End: 1, PageUp: 1, PageDown: 1
    };
    var lastBrowseKeyAt = 0;
    var pendingCommit = false;

    select.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        pendingCommit = false;
        return;
      }
      if (BROWSE_KEYS[e.key] || (e.key && e.key.length === 1)) {
        lastBrowseKeyAt = Date.now();
        return;
      }
      if (e.key !== 'Enter' || !pendingCommit) return;
      // Commit the pending keyboard selection rather than submitting the search form.
      e.preventDefault();
      pendingCommit = false;
      gdsGoToDept(select);
    });

    select.addEventListener('change', function () {
      // Arrow keys / type-ahead on a closed select change the value while the
      // shopper is still browsing, so wait for Enter (or blur) before leaving.
      // A committed pick (mouse click, or Enter inside the native popup) has no
      // recent key event on the select itself and navigates right away.
      if (Date.now() - lastBrowseKeyAt < 250) {
        pendingCommit = true;
        return;
      }
      pendingCommit = false;
      gdsGoToDept(select);
    });

    select.addEventListener('blur', function () {
      if (!pendingCommit) return;
      pendingCommit = false;
      gdsGoToDept(select);
    });
  });

  /* Restore department from URL when landing on search results */
  (function restoreSearchDept() {
    try {
      var params = new URLSearchParams(window.location.search);
      var dept = params.get('gds_dept') || '';
      if (!dept && params.get('filter.p.tag')) {
        var tag = params.get('filter.p.tag');
        var tagMap = {
          'dept:electronics': 'shop-home-electronics',
          'dept:home-electronics': 'shop-home-electronics',
          'dept:home-living': 'shop-home-living-aisle',
          'dept:beauty-skincare': 'shop-beauty-skincare-hub',
          'dept:fitness': 'fitness-gym',
          'dept:pet': 'shop-pet-accessories',
          'dept:summer': 'shop-summer-essentials-aisle',
          'dept:baby-kids': 'baby-kids-essentials',
          'dept:womens-clothing': 'womens',
          'dept:wedding': 'shop-wedding',
          'dept:eco-living': 'shop-eco-living-aisle'
        };
        dept = tagMap[tag] || (tag.indexOf('dept:') === 0 ? tag.slice(5) : '');
      }
      if (!dept) {
        // Landing on a department collection should show that department as selected.
        var colMatch = (window.location.pathname || '').match(/^\/collections\/([^\/?#]+)/);
        if (colMatch) dept = decodeURIComponent(colMatch[1]);
      }
      if (!dept) return;
      document.querySelectorAll('[data-gds-search-dept]').forEach(function (sel) {
        if ([].some.call(sel.options, function (o) { return o.value === dept; })) {
          sel.value = dept;
        }
      });
    } catch (err) {}
  })();

  /* ─── Mega dept panel switcher (data-dept → #panel-dN) ─── */
  function subcatGridCols(n) {
    var w = window.innerWidth;
    var maxCols = 5;
    if (w <= 720) maxCols = 2;
    else if (w <= 900) maxCols = 3;
    else if (w <= 1024) maxCols = 4;
    else if (w <= 1200) maxCols = 4;
    // Prefer a 4-up row when there are 2–4 tiles (empty trailing slot).
    var preferred = n;
    if (n >= 2 && n <= 4) preferred = 4;
    return Math.min(preferred, maxCols);
  }

  function setSubcatRowCount(grid) {
    var n = grid.querySelectorAll('.mega-subcat-card').length;
    var cols = n;
    if (n >= 2 && n <= 4) cols = 4;
    else if (n >= 5) cols = Math.min(n, 5);
    grid.classList.forEach(function (cls) {
      if (/^mega-subcat-row--count-\d+$/.test(cls)) grid.classList.remove(cls);
    });
    if (cols) grid.classList.add('mega-subcat-row--count-' + cols);
    return n;
  }

  function fitMegaSubcatGrid(grid) {
    if (!grid) return;
    grid.classList.remove('mega-subcat-row--fit');
    grid.style.removeProperty('--mega-subcat-size');

    var panel = grid.closest('.dept-panel');
    if (panel && !panel.classList.contains('active')) return;

    var n = setSubcatRowCount(grid);
    if (!n) return;

    var cols = subcatGridCols(n);
    var rows = Math.ceil(n / cols);
    if (rows <= 1) return;

    var panelWrap = grid.closest('.mega-text-panel');
    var megaTop = grid.closest('.mega-top');
    if (!megaTop || !panelWrap) return;

    var head = panelWrap.querySelector('.mega-cat-dir-head');
    var headH = head ? head.offsetHeight + 18 : 0;
    var padY = 44;
    var bodyH = megaTop.getBoundingClientRect().height - headH - padY;
    if (bodyH < 100) return;

    var gap = parseFloat(getComputedStyle(grid).rowGap) || 16;
    var colGap = parseFloat(getComputedStyle(grid).columnGap) || 16;
    var labelAllow = 32;
    var gridW = grid.clientWidth;
    if (!gridW) return;

    var tileW = (gridW - colGap * (cols - 1)) / cols;
    var needH = rows * (tileW + labelAllow) + gap * (rows - 1);

    if (needH > bodyH) {
      var fitW = (bodyH - gap * (rows - 1) - rows * labelAllow) / rows;
      fitW = Math.max(52, Math.min(tileW, fitW));
      grid.style.setProperty('--mega-subcat-size', fitW + 'px');
      grid.classList.add('mega-subcat-row--fit');
    }
  }

  function fitActiveMegaSubcatGrid(root) {
    var panel = root && root.classList && root.classList.contains('dept-panel')
      ? root
      : document.querySelector('.dept-panels--text .dept-panel.active');
    if (!panel) return;
    var grid = panel.querySelector('.mega-subcat-row');
    if (grid) fitMegaSubcatGrid(grid);
  }

  function initSubcatRowCounts() {
    document.querySelectorAll('.dept-panels--text .mega-subcat-row').forEach(setSubcatRowCount);
  }

  function tagMegaTileGrids(root) {
    var scope = root || document;
    scope.querySelectorAll('.mega-dept-tiles').forEach(function (grid) {
      grid.classList.forEach(function (cls) {
        if (/^mega-dept-tiles--count-\d+$/.test(cls)) grid.classList.remove(cls);
      });
      const n = grid.querySelectorAll('.mega-dept-tile').length;
      if (n) grid.classList.add('mega-dept-tiles--count-' + n);
    });
  }

  function alignNavMegas() {
    document.querySelectorAll('.nav-item--mega').forEach(function (item) {
      item.classList.remove('nav-item--align-right');
      const mega = item.querySelector('.nav-mega');
      if (!mega) return;
      const rect = mega.getBoundingClientRect();
      if (rect.right > window.innerWidth - 8) {
        item.classList.add('nav-item--align-right');
      }
    });
  }

  function initNavMegas() {
    document.querySelectorAll('.nav-item--mega').forEach(function (item) {
      const trigger = item.querySelector('.nav-trigger');
      if (!trigger) return;
      item.addEventListener('mouseenter', function () {
        document.querySelectorAll('.nav-item--mega .nav-trigger').forEach(function (t) {
          t.setAttribute('aria-expanded', 'false');
        });
        trigger.setAttribute('aria-expanded', 'true');
        tagMegaTileGrids(item);
        alignNavMegas();
      });
      item.addEventListener('focusin', function () {
        trigger.setAttribute('aria-expanded', 'true');
        tagMegaTileGrids(item);
        alignNavMegas();
      });
      item.addEventListener('mouseleave', function () {
        trigger.setAttribute('aria-expanded', 'false');
      });
    });
    tagMegaTileGrids();
    alignNavMegas();
  }

  function updateMegaViewport() {
    const header = document.querySelector('header.site');
    const strip = document.querySelector('.mega-promo-strip');
    if (!header) return;
    const headerBottom = header.getBoundingClientRect().bottom;
    const stripH = strip ? strip.offsetHeight : 68;
    const maxH = Math.max(320, window.innerHeight - headerBottom);
    document.documentElement.style.setProperty('--gds-mega-max-h', maxH + 'px');
    document.documentElement.style.setProperty('--gds-mega-strip-h', stripH + 'px');
    initSubcatRowCounts();
    fitActiveMegaSubcatGrid();
    alignNavMegas();
  }

  updateMegaViewport();
  initNavMegas();
  initSubcatRowCounts();
  window.addEventListener('resize', function () {
    updateMegaViewport();
    alignNavMegas();
  });
  const allDepts = document.querySelector('.all-depts');
  const allDeptsMega = allDepts ? allDepts.querySelector('.mega') : null;
  if (allDepts) {
    allDepts.addEventListener('mouseenter', updateMegaViewport);
    allDepts.addEventListener('focusin', updateMegaViewport);
  }

  function closeTouchMega() {
    if (!allDepts) return;
    allDepts.classList.remove('mega-open');
    if (allDeptsMega) allDeptsMega.style.display = '';
  }

  function initTouchMega() {
    if (!allDepts || !allDeptsMega) return;
    var touchMq = window.matchMedia('(hover: none), (pointer: coarse)');

    allDepts.addEventListener('click', function (e) {
      if (window.innerWidth <= 980 || !touchMq.matches) return;
      if (e.target.closest('.mega a, .mega button, .mega select, .mega input')) return;
      e.preventDefault();
      e.stopPropagation();
      var open = !allDepts.classList.contains('mega-open');
      allDepts.classList.toggle('mega-open', open);
      allDeptsMega.style.display = open ? 'block' : '';
      if (open) updateMegaViewport();
    });

    document.addEventListener('click', function (e) {
      if (!allDepts.classList.contains('mega-open')) return;
      if (allDepts.contains(e.target)) return;
      closeTouchMega();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeTouchMega();
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth <= 980 || !touchMq.matches) closeTouchMega();
    });
  }
  initTouchMega();

  var activeDeptId = null;

  var initialDept = document.querySelector('.mega-depts--full .dept-link.active');
  if (initialDept && initialDept.dataset.dept) {
    activeDeptId = initialDept.dataset.dept;
  }

  function showDeptPanel(link) {
    if (!link) return;
    const dept = link.dataset.dept;
    if (!dept || activeDeptId === dept) return;
    activeDeptId = dept;
    document.querySelectorAll('.dept-link').forEach(function (l) {
      l.classList.remove('active');
      l.setAttribute('aria-expanded', 'false');
    });
    document.querySelectorAll('.dept-panels--text .dept-panel').forEach(function (p) {
      p.classList.remove('active');
    });
    link.classList.add('active');
    link.setAttribute('aria-expanded', 'true');
    const panel = document.getElementById('panel-' + dept);
    if (panel) {
      panel.classList.add('active');
      fitActiveMegaSubcatGrid(panel);
    }
  }

  document.addEventListener('mouseover', function (e) {
    var link = e.target && e.target.closest && e.target.closest('.mega-depts .dept-link');
    if (link) showDeptPanel(link);
  });
  document.addEventListener('focusin', function (e) {
    var link = e.target && e.target.closest && e.target.closest('.mega-depts .dept-link');
    if (link) showDeptPanel(link);
  });
  document.addEventListener('click', function (e) {
    var link = e.target && e.target.closest && e.target.closest('.mega-depts .dept-link');
    if (link) showDeptPanel(link);
  });

  /* ─── Refresh stale All Departments mega (sticky homepage page_cache) ─── */
  (function refreshStaleDeptMega() {
    var rows = document.querySelectorAll('.dept-panels--text .mega-subcat-row');
    if (!rows.length) return;
    var empty = 0;
    rows.forEach(function (row) {
      if (!row.querySelector('.mega-subcat-card')) empty += 1;
    });
    if (empty < 1) return;

    var liveMega = document.querySelector('.mega-top--costco');
    var sectionEl = document.querySelector('[id^="shopify-section-"][id*="gds_header"]');
    if (!liveMega || !sectionEl) return;

    var sectionId = sectionEl.id.replace(/^shopify-section-/, '');
    var candidates = [];
    var v3Id = sectionId.replace(/gds_header(?:_v\d+)?/, 'gds_header_v3');
    if (v3Id && candidates.indexOf(v3Id) === -1) candidates.push(v3Id);
    if (candidates.indexOf(sectionId) === -1) candidates.push(sectionId);

    function applyMegaHtml(html) {
      if (!html || html.indexOf('mega-subcat-card') === -1) return false;
      var wrap = document.createElement('div');
      wrap.innerHTML = html;
      var freshMega = wrap.querySelector('.mega-top--costco');
      if (!freshMega) return false;
      liveMega.replaceWith(freshMega);
      activeDeptId = null;
      var first = document.querySelector('.mega-depts--full .dept-link');
      if (first && first.dataset.dept) activeDeptId = first.dataset.dept;
      initSubcatRowCounts();
      fitActiveMegaSubcatGrid();
      return true;
    }

    function tryFetch(i) {
      if (i >= candidates.length) return;
      var id = candidates[i];
      if (!id) return tryFetch(i + 1);
      fetch('/?sections=' + encodeURIComponent(id), { credentials: 'same-origin' })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (data) {
          var html = data && (data[id] || data[Object.keys(data || {})[0]]);
          if (applyMegaHtml(html)) return;
          tryFetch(i + 1);
        })
        .catch(function () { tryFetch(i + 1); });
    }

    tryFetch(0);
  })();

  /* ─── Scroll Carousel ─── */
  window.gdsScrollCarousel = function (id, dir, dist) {
    const el = document.getElementById(id);
    if (el) el.scrollBy({ left: dir * (dist || 300), behavior: 'smooth' });
  };

  /* ─── Hotspot tap (mobile / touch support) ─── */
  function gdsSetHotspotActive(hotspot, on) {
    hotspot.classList.toggle('active', on);
    hotspot.setAttribute('aria-expanded', on ? 'true' : 'false');
  }

  document.querySelectorAll('.hotspot').forEach(function (h) {
    h.addEventListener('click', function (e) {
      if (e.target.closest('a')) return;
      e.stopPropagation();
      document.querySelectorAll('.hotspot.active').forEach(function (o) {
        if (o !== h) gdsSetHotspotActive(o, false);
      });
      gdsSetHotspotActive(h, !h.classList.contains('active'));
    });
    h.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault();
      h.click();
    });
  });
  document.addEventListener('click', function () {
    document.querySelectorAll('.hotspot.active').forEach(function (h) {
      gdsSetHotspotActive(h, false);
    });
  });

  /* ─── Shop the Look: add all hotspot products to cart ─── */
  document.querySelectorAll('[data-gds-look-add-all]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var sectionId = btn.getAttribute('data-look-section');
      var root = sectionId ? document.getElementById(sectionId) : btn.closest('[data-gds-look]');
      if (!root) return;

      var items = [];
      root.querySelectorAll('.hotspot[data-variant-id][data-available="true"]').forEach(function (h) {
        var id = parseInt(h.getAttribute('data-variant-id'), 10);
        if (id && items.every(function (it) { return it.id !== id; })) {
          items.push({ id: id, quantity: 1 });
        }
      });

      if (!items.length) return; // fall through to href

      e.preventDefault();
      if (btn.getAttribute('aria-busy') === 'true') return;
      btn.setAttribute('aria-busy', 'true');
      var label = btn.textContent;
      btn.textContent = 'Adding…';

      fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add failed');
          return res.json();
        })
        .then(function () {
          window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart';
        })
        .catch(function () {
          btn.textContent = label;
          btn.removeAttribute('aria-busy');
          window.location.href = btn.getAttribute('href') || '/collections/shop-home-living-aisle';
        });
    });
  });

  /* ─── Reveal observer ─── */
  const revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length) {
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
      revealEls.forEach(function (el) { io.observe(el); });
    } else {
      revealEls.forEach(function (el) { el.classList.add('in-view'); });
    }
    setTimeout(function () {
      revealEls.forEach(function (el) { el.classList.add('in-view'); });
    }, 1800);
  }

  /* ─── Countdown timer (only when a real end datetime is present) ─── */
  document.querySelectorAll('[data-countdown-end]').forEach(function (strip) {
    var endStr = strip.dataset.countdownEnd;
    if (!endStr) return;
    var endTime = new Date(endStr).getTime();
    if (isNaN(endTime)) return;

    var daysEl = strip.querySelector('.cd-days');
    var hrsEl  = strip.querySelector('.cd-hrs');
    var minEl  = strip.querySelector('.cd-min');
    var timerEl = strip.querySelector('[data-gds-deal-timer]') || strip.querySelector('.timer');
    if (!daysEl && !hrsEl && !minEl) return;

    function hideExpired() {
      if (timerEl) timerEl.hidden = true;
      strip.removeAttribute('data-countdown-end');
    }

    function tick() {
      var now  = Date.now();
      var diff = Math.max(0, endTime - now);
      var totalMin = Math.floor(diff / 60000);
      var totalHrs = Math.floor(totalMin / 60);
      var days = Math.floor(totalHrs / 24);
      var hrs  = totalHrs % 24;
      var mins = totalMin % 60;

      if (daysEl) daysEl.textContent = days;
      if (hrsEl)  hrsEl.textContent  = hrs;
      if (minEl)  minEl.textContent  = mins;

      if (diff === 0) {
        clearInterval(timer);
        hideExpired();
      }
    }

    if (endTime <= Date.now()) {
      hideExpired();
      return;
    }

    tick();
    var timer = setInterval(tick, 30000);
  });

  /* Normalize outdated admin email on policy pages (incl. cached Privacy HTML). */
  function gdsNormalizeSupportEmail() {
    var from = 'gooddealinternationalco@gmail.com';
    var to = 'support@gooddealsuperstore.com';
    if (!document.body || document.body.innerHTML.indexOf(from) === -1) return;
    var roots = document.querySelectorAll('.shopify-policy__body, .policy-body, .rte, article.policy-main');
    if (!roots.length) roots = [document.body];
    roots.forEach(function (el) {
      if (el && el.innerHTML && el.innerHTML.indexOf(from) !== -1) {
        el.innerHTML = el.innerHTML.split(from).join(to);
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', gdsNormalizeSupportEmail);
  } else {
    gdsNormalizeSupportEmail();
  }

})();
